import React from 'react';
import { Badge } from './ui/badge';
import { Truck, ClipboardCheck, Route } from 'lucide-react';

const POINTS = [
  { icon: ClipboardCheck, titre: 'La bonne benne', texte: 'Volume et type de benne adaptés à vos déchets, aux accès de votre chantier et à vos délais.' },
  { icon: Truck, titre: 'Livraison, rotations, enlèvement', texte: "Nous organisons chaque étape : dépôt, rotation quand la benne est pleine, retrait et traitement en centre agréé." },
  { icon: Route, titre: 'Un interlocuteur concret', texte: 'Service réactif, tarifs clairs affichés avant commande et accompagnement sur les démarches (accès, voirie).' },
];

const NotreExperience = () => (
  <section id="notre-experience" className="py-20 bg-gray-950 text-white scroll-mt-28" data-testid="notre-experience-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-12 lg:gap-20 items-start">
      <div className="space-y-6">
        <Badge className="bg-green-600/20 text-green-400 hover:bg-green-600/20 border border-green-600/40">À propos</Badge>
        <h2 className="text-3xl sm:text-4xl font-bold leading-tight">Notre expérience</h2>
        <p className="text-base md:text-lg font-semibold text-green-400">L'expérience du terrain au service de vos chantiers</p>
        <p className="text-sm sm:text-base text-gray-300 leading-relaxed" data-testid="notre-experience-text">
          Forte de plusieurs années d'expérience dans la gestion des déchets et la location de bennes, l'équipe de
          LocaBenne EcoRipeurs BTP accompagne les professionnels et les particuliers dans l'évacuation de leurs déchets
          en Île-de-France. Notre connaissance du terrain nous permet de vous proposer la benne adaptée à vos déchets,
          aux accès de votre chantier et à vos délais. Nous organisons la livraison, les rotations et l'enlèvement avec
          une priorité : simplifier la gestion de vos déchets grâce à un service réactif, des tarifs clairs et un
          accompagnement concret.
        </p>
      </div>
      <div className="grid gap-5">
        {POINTS.map((p) => (
          <div key={p.titre} className="flex gap-4 p-5 rounded-xl bg-white/5 border border-white/10">
            <div className="shrink-0 h-11 w-11 rounded-lg bg-green-600 flex items-center justify-center">
              <p.icon className="h-5 w-5 text-white" />
            </div>
            <div>
              <h3 className="font-bold text-white mb-1">{p.titre}</h3>
              <p className="text-sm text-gray-300 leading-relaxed">{p.texte}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default NotreExperience;
